import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
@Injectable()
export class LoaderService {
  public loader = new BehaviorSubject(null);
  constructor () {}

  setLoader(state) {
    this.loader.next(state);
  }
}
